
import React, { useState, useMemo } from 'react';
import { Card } from 'react-bootstrap';
import { FaBell, FaBellSlash, FaCalendarDay, FaCoins } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

// Helper: بررسی اینکه آیا تاریخ آبیاری برای امروز هست یا نه
const isToday = (dateStr) => {
  const today = new Date();
  const date = new Date(dateStr);
  return (
    today.getDate() === date.getDate() &&
    today.getMonth() === date.getMonth() &&
    today.getFullYear() === date.getFullYear()
  );
};

const ReminderStats = ({ reminders, maxReminder, validDueDate }) => {
  const stats = useMemo(() => {
    const total = reminders.length;
    const inactive = reminders.filter((r) => !r.isActive).length;
    const today = reminders.filter(
      (r) => r.isActive && r.nextWatering && isToday(r.nextWatering)
    ).length;

    return { total, inactive, today };
  }, [reminders]);

  const StatCard = ({ icon, value, label, color, onClick }) => (
    <Card className="text-center p-3 shadow-sm flex-fill" style={{ minWidth: 150 }} onClick={onClick}>
      <div className="mb-2" style={{ fontSize: '1.8rem', color }}>{icon}</div>
      <div style={{ fontSize: '1.7rem', fontWeight: 'bold' }}>{value}</div>
      <div className="text-muted" style={{ fontSize: '0.9rem' }}>{label}</div>
    </Card>
  );


  const navigate = useNavigate(); // Initialize useNavigate
  
  return (
    <div className="d-flex gap-3 flex-wrap mb-4">
      <StatCard
        icon={<FaBell />}
        value={stats.total}
        label="کل یادآورها"
        color="#0d6efd"
      />
        <StatCard
        icon={<FaCalendarDay />}
        value={stats.today}
        label="یادآورهای امروز"
        color="#198754"
      />

      <StatCard
        icon={<FaBellSlash />}
        value={stats.inactive}
        label="یادآور غیرفعال"
        color="#dc3545"
      />

    <StatCard
        icon={<FaCoins />}
        value={maxReminder}
        label={`اعتبار  ${validDueDate.message}`}
        onClick={(e)=>{   navigate('/plans?source=credit-box') }}
        color={ validDueDate.value < 1 ? "#ff006fff" :"#ffcc00"}
      />
    
    
    </div>
  );
};

export default ReminderStats;
